<template>
  <div class="input-group input-group--select mb-3">
    <label
      v-if="label"
      class="caption"
    >
      {{ label }}<span v-if="required">*</span>
    </label>
    <div
      v-if="caption"
      class="caption mb-1 error--text"
      v-html="`<div>${caption}</div>`"
    />
    <v-layout
      :column="breakpoint.smAndDown"
      :align-center="!breakpoint.smAndDown"
      style="width:100%"
    >
      <a
        target="_blank"
        style="text-decoration: underline"
        @click.prevent="loadPdf"
      >{{ pdf.originalName }}</a>
      <v-flex
        :class="progressCellClass"
      >
        <v-progress-linear
          v-if="loading"
          :value="progress"
          height="15"
          color="primary"
          style="position: relative"
        />
        <span
          v-else-if="error"
          class="error--text"
        >
          {{ error }}
        </span>
      </v-flex>
      <v-flex
        md2
        class="text-xs-right"
      >
        <input
          ref="input"
          :name="name"
          type="file"
          accept="application/pdf"
          style="display: none"
          @change="upload"
        >
        <v-btn
          :loading="loading"
          color="primary"
          class="my-0"
          large
          block
          @click="input"
        >PDFをアップロード</v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { uploadFile } from 'cp-ui/src/upload';

export default {
  props: {
    name: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    pdf: {
      type: Object,
      default() {
        return {};
      },
    },
    confidential: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    caption: {
      type: String,
      default: '',
    },
    preview: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      progress: 0,
    };
  },
  computed: {
    progressCellClass() {
      return [
        'py-2',
        {
          'pr-3': !this.breakpoint.smAndDown,
        },
      ];
    },
  },
  methods: {
    loadPdf() {
      this.$emit('load-pdf');
    },
    input() {
      this.$refs.input.click();
    },
    async upload() {
      this.loading = true;

      const selectedFile = event.target.files[0];
      if (!selectedFile) return;

      try {
        await uploadFile(
          {
            file: this.$refs.input.files[0],
            $apollo: this.$apollo,
            confidential: this.confidential,
            target: 'shakensho', // To make sure the file is uploaded to the correct S3 folder
            variables: {
              appointmentId: parseInt(this.$route.params.id, 10),
              type: 'PTS_CERT_ADV',
              description: this.description,
            },
            onError: this.onErrorUpload,
            onUploadProgress: (event) => {
              this.progress = (event.loaded / event.total) * 100;
            },
          },
        );
      } catch (error) {
        this.onErrorUpload({ status: error });
        return;
      }

      this.$emit('finished');
      this.onSuccessUpload();
    },
    onErrorUpload({ status }) {
      this.loading = false;
      this.progress = 0;
      this.$emit('upload-error', { status });
    },
    onSuccessUpload() {
      this.loading = false;
      this.progress = 0;
    },
    change() {
      this.$emit('change', this.$refs.input.files[0]);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/elements/CpPdf.vue